/* eslint-disable max-len */
import React, {
  useState, useCallback, forwardRef, useImperativeHandle, useRef,
} from 'react';

import {
  Form, Input, Button, notification, Row, Col,
} from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import * as Yup from 'yup';

import useManager from '../../../hooks/manager';
import Modal from '../../Modal';

const NewForm = (_props, ref) => {
  const [validationErrors, setValidationErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [useToken, setUseToken] = useState(false);
  const [useUserName, setUseUserName] = useState(false);
  const [usePassword, setUsePassword] = useState(false);
  const [useClientID, setUseClientID] = useState(false);
  const [useClientSecret, setUseClientSecret] = useState(false);
  const [useLocalUrl, setUseLocalUrl] = useState(false);
  const [useUrlAppIntegration, setUseUrlAppIntegration] = useState(false);
  const { store } = useManager();
  const formRef = useRef();

  useImperativeHandle(ref, () => ({
    open: () => setShowModal(true),
  }));

  const handleSubmit = useCallback(() => {
    (async () => {
      try {
        setLoading(true);
        const data = {
          ...formRef.current.getFieldsValue(),
          useToken,
          useUserName,
          usePassword,
          useClientID,
          useClientSecret,
          useLocalUrl,
          useUrlAppIntegration,
        };

        const schema = Yup.object().shape({
          name: Yup.string().required('Informe o nome'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        // validation passed
        store('/appintegration', data, () => {
          formRef.current.resetFields();
          setValidationErrors({});
          setShowModal(false);
        });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log(err);
        setValidationErrors({});
        // Validation failed
        if (err instanceof Yup.ValidationError) {
          notification.error({
            message: 'Falha na Validação',
          });
          const ve = {};
          err.inner.forEach((e) => {
            ve[e.path] = e.message;
          });
          setValidationErrors(ve);
          return;
        }

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;
          notification.error({
            message,
          });

          return;
        }

        notification.error({
          message: 'Falha ao cadastrar',
        });
      }
    })();
  }, [store, useToken, useUserName, usePassword, useClientID, useClientSecret, useLocalUrl, useUrlAppIntegration]);

  return (
    <Modal
      title="Novo App de Integração"
      visible={showModal}
      loading={loading}
      footer={(
        <Button type="primary" size="large" onClick={handleSubmit}>
          Cadastrar
        </Button>
      )}
      onClose={() => setShowModal(false)}
    >
      <Form ref={formRef} size="large">
        <Form.Item
          name="name"
          validateStatus={validationErrors.name ? 'error' : ''}
          help={validationErrors.name}
          hasFeedback
        >
          <Input placeholder="Nome" />
        </Form.Item>
        <Form.Item name="useLocalUrl">
          <Checkbox
            checked={useLocalUrl}
            onChange={() => setUseLocalUrl((prevState) => !prevState)}
          >
            Utiliza Local URL
          </Checkbox>
        </Form.Item>
        <Row>
          <Col xs={6}>
            <Form.Item name="useUrlAppIntegration">
              <Checkbox
                checked={useUrlAppIntegration}
                onChange={() => setUseUrlAppIntegration((prevState) => !prevState)}
              >
                Utiliza URL API de Integração
              </Checkbox>
            </Form.Item>
          </Col>
          <Col xs={12}>
            {useUrlAppIntegration ? (
              <Form.Item name="defaultUrlAppIntegration">
                <Input placeholder="Valor Default" />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Form.Item name="useToken">
              <Checkbox
                checked={useToken}
                onChange={() => setUseToken((prevState) => !prevState)}
              >
                Utiliza Token
              </Checkbox>
            </Form.Item>
          </Col>
          <Col xs={12}>
            {useToken ? (
              <Form.Item name="defaultToken">
                <Input placeholder="Valor Default" />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Form.Item name="useUserName">
              <Checkbox
                checked={useUserName}
                onChange={() => setUseUserName((prevState) => !prevState)}
              >
                Utiliza Nome de Usuário
              </Checkbox>
            </Form.Item>
          </Col>
          <Col xs={12}>
            {useUserName ? (
              <Form.Item name="defaultUserName">
                <Input placeholder="Valor Default" />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Form.Item name="usePassword">
              <Checkbox
                checked={usePassword}
                onChange={() => setUsePassword((prevState) => !prevState)}
              >
                Utiliza Senha
              </Checkbox>
            </Form.Item>
          </Col>
          <Col xs={12}>
            {usePassword ? (
              <Form.Item name="defaultPassword">
                <Input placeholder="Valor Default" />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Form.Item name="useClientID">
              <Checkbox
                checked={useClientID}
                onChange={() => setUseClientID((prevState) => !prevState)}
              >
                Utiliza Cliente ID
              </Checkbox>
            </Form.Item>
          </Col>
          <Col xs={12}>
            {useClientID ? (
              <Form.Item name="defaultClientID">
                <Input placeholder="Valor Default" />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Form.Item name="useClientSecret">
              <Checkbox
                checked={useClientSecret}
                onChange={() => setUseClientSecret((prevState) => !prevState)}
              >
                Utiliza Cliente Secret
              </Checkbox>
            </Form.Item>
          </Col>
          <Col xs={12}>
            {useClientSecret ? (
              <Form.Item name="defaultClientSecret">
                <Input placeholder="Valor Default" />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default forwardRef(NewForm);
